export default "__VITE_ASSET__DfA9y18$__"